import React from 'react';
import { Typography } from '@metarouter-private/mr-mui';

const ERROR_MESSAGE = "Couldn't load audit history.";

export default function AuditLogErrorState() {
  return (
    <Typography data-test-id="auditLogErrorState" color="error">
      {ERROR_MESSAGE}
    </Typography>
  );
}
